import { Component } from '@angular/core';
import { TranslatorService } from './services/translator-service/translator.service';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from './services/loading-service/loading.service';
import { delay } from 'rxjs';
import { EnvironmentConfigService } from './services/environment-config-service/environment-config-service';
import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { accessibilityOutline, add, addCircleOutline, addOutline, alertCircleOutline, arrowBack, arrowBackOutline, arrowUndoOutline, arrowUpOutline, bluetooth, bodyOutline, checkmarkOutline, chevronForwardOutline, close, code, copyOutline, documentOutline, eyeOffOutline, eyeOutline, gridOutline, homeOutline, keyOutline, linkOutline, mailOutline, pencilOutline, person, personOutline, refreshOutline, returnDownBackOutline, saveOutline, sparklesOutline, text, textOutline, trashOutline, unlinkSharp } from 'ionicons/icons';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  loading = false;
  isReady = false;

  constructor(
    protected _translate: TranslateService,
    protected _translationService: TranslatorService,
    protected platform: Platform,
    protected environment: EnvironmentConfigService
  ) {
    this.platform.ready().then(async (value: string) => {
      try {
        await this.initializeApp(value);
        console.log("APP INITIALIZED");
      } catch (err) {
        console.error('App initialization failed', err);
        // optionally set fallback state or show an error overlay
      } finally {
        // Hide Splashscreen if any
        this.isReady = true;
      }
    });
  }

  async initializeApp(value: string) {
    await App.removeAllListeners();
    // Setup Environemt
    await this.environment.initService();
    await this.environment.EnsureNetworkConfiguration();
    // Loading Service
    LoadingService.init();
    this.listenToLoading();
    // Translations
    await this._translationService.useLanguage(this._translationService.getCurrentLanguage());
    this._translate.onLangChange.subscribe(() => { });
    // App pause/resume listener
    await App.addListener('appStateChange', async (state) => {
      console.log("App State", state);
      if (state.isActive) {
        // App Resumed
      } else {
        // App Paused
      }
    });
    addIcons({
      add,
      close,
      arrowBack,
      bluetooth,
      chevronForwardOutline,
      textOutline,
      mailOutline,
      arrowUndoOutline,
      addCircleOutline,
      bodyOutline,
      refreshOutline,
      gridOutline,
      homeOutline,
      person,
      personOutline,
      text,
      code,
      keyOutline,
      arrowUpOutline,
      arrowBackOutline,
      documentOutline,
      addOutline,
      linkOutline,
      trashOutline,
      saveOutline,
      returnDownBackOutline,
      accessibilityOutline,
      checkmarkOutline,
      pencilOutline,
      unlinkSharp,
      eyeOffOutline,
      eyeOutline,
      alertCircleOutline,
      copyOutline,
      sparklesOutline
    });
  }

  listenToLoading(): void {
    LoadingService.loadingSub
      .pipe(delay(0))
      .subscribe((loading: any) => {
        this.loading = loading;
      });
  }
}